import { createHttpClient } from "./http";

export class CultivoRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 30000 });
	}

	async getAll(params) {
		try {
			const result = await this.axios.get("cultivation", {
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`
				},
				params: params
			});

			return result.data;
		} catch (error) {
			console.log(error);
			if(error.response?.status === 401) {
				window.location.href = "/";
				throw new Error("Usuário não autenticado.");
			}

			throw new Error("Erro ao carregar cultivos.");
		}
	}
}
